export default __webpack_public_path__ + "static/media/01.43b5e2d2.jpg";